import React, { useState } from 'react';
import { Box, Typography, Breadcrumbs, Button, Paper, Stack, Divider, alpha } from '@mui/material';
import { Add, ChevronRight, ShieldOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import Layout from '../../../components/common/Layout';
import RoleList from './RoleList';
import CreateRoleModal from './CreateRole/RoleModal';

const UserRoles = ({ className }) => {
  const [roleModal, setRoleModal] = useState(false);
  const [isMounted, setMounted] = useState(false);

  const showModal = () => {
    setRoleModal(true);
    setMounted(true);
  };

  const closeModal = () => {
    setRoleModal(false);
    setMounted(false);
  };

  return (
    <Layout headerTitle="Settings">
      {isMounted && <CreateRoleModal open={roleModal} close={closeModal} title="Create New Role" />}

      <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F4F6F8', minHeight: '100vh', mt: -1 }}>
        {/* BREADCRUMBS */}
        <Breadcrumbs separator={<ChevronRight fontSize="small" />} sx={{ mb: 2 }}>
          <Link to="/settings" style={{ textDecoration: 'none' }}>
            <Typography
              variant="body2"
              sx={{
                color: 'primary.main',
                fontWeight: 600,
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Settings
            </Typography>
          </Link>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            User Roles
          </Typography>
        </Breadcrumbs>

        {/* HEADER SECTION */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: '16px',
            border: '1px solid',
            borderColor: 'divider',
            background: '#fff',
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            spacing={2}
          >
            <Box>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.5 }}>
                <Box
                  sx={{
                    p: 1,
                    display: 'flex',
                    borderRadius: '10px',
                    bgcolor: alpha('#1976d2', 0.1),
                    color: 'primary.main',
                  }}
                >
                  <ShieldOutlined fontSize="small" />
                </Box>
                <Typography variant="h5" fontWeight={700} color="text.primary">
                  User Roles
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary">
                Roles define what permissions and access levels are granted to user accounts.
              </Typography>
            </Box>

            <Button
              variant="contained"
              disableElevation
              startIcon={<Add />}
              onClick={showModal}
              sx={{
                borderRadius: '10px',
                textTransform: 'none',
                fontWeight: 700,
                px: 3,
                py: 1,
              }}
            >
              New Role
            </Button>
          </Stack>
        </Paper>

        {/* CONTENT AREA */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: '16px',
            border: '1px solid',
            borderColor: 'divider',
            overflow: 'hidden',
            bgcolor: 'transparent', // The Paper inside RoleList will provide the cards
          }}
        >
          <Box sx={{ p: 0 }}>
            <RoleList />
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UserRoles;
